import { render, staticRenderFns } from "./MediateDirectorGroupManage.vue?vue&type=template&id=4751f96b&"
import script from "./MediateDirectorGroupManage.vue?vue&type=script&lang=js&"
export * from "./MediateDirectorGroupManage.vue?vue&type=script&lang=js&"
import style0 from "./MediateDirectorGroupManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports